import { useState, useEffect } from 'react';
import './css/BottomSection.css';
import { InvoiceService } from 'src/services/InvoiceService';
import Swal from 'sweetalert2';
import { environment } from 'src/environment/environment';
import { PaymentOptions } from 'src/enums/PaymentOptions';
import { Util } from 'src/Util';
import moment from 'moment';

const BottomSection = (invoiceData: any) => {
  const [invoiceCurrency, setInvoiceCurrency] = useState('');
  const [
    isProductOrCategoryDiscountsAvailable,
    setIsProductOrCategoryDiscountsAvailable
  ] = useState(false);
  const [invoiceValueWithDiscounts, setinvoiceValueWithDiscounts] = useState<number>(0);
  const [updatedInvoiceValue, setUpdatedInvoiceValue] = useState<number>(0);
  let [invoiceValueAfterCharge, setInvoiceValueAfterCharge] =
    useState<number>(0);
  const [firstFieldAmount, setfirstFieldAmount] = useState<number>(0);
  const [serviceCharge, setServiceCharge] = useState<number>(0);
  const [cardPaymentCharge, setCardPaymentCharge] = useState<number>(0);
  const [digitalPaymentCharge, setDigitalPaymentCharge] = useState<number>(0);
  const [isLoading, setIsLoading] = useState(true);
  const [errorOccurred, setErrorOccurred] = useState(false);
  const [error, setError] = useState<string | undefined>();
  const [totalOustandingAmount, setTotalOustandingAmount] = useState<any>(null);
  const [taxCharge, setTaxCharge] = useState<number>(0);
  const [deliveryCharge, setDeliveryCharge] = useState<number>(0);
  const [labourCharge, setLabourCharge] = useState<number>(0);
  const [creditSettleValues, setCreditSettleValues] = useState<any[]>([]);

  useEffect(() => {
    let rawTotalValue = invoiceData.invoiceData?.subTotal;
    let totalValue = rawTotalValue;

    setinvoiceValueWithDiscounts(rawTotalValue);

    setInvoiceCurrency(invoiceData.invoiceData?.originalCurrency?.currencyName);

    if (invoiceData.invoiceData?.invoiceItems != null) {
      invoiceData.invoiceData?.invoiceItems.forEach((item: any) => {
        if (
          item.productOrCategoryDiscount != null &&
          item.productOrCategoryDiscount > 0
        ) {
          if (item.productOrCategoryDiscountType == 'PAYRATE') {
            if (invoiceData.invoiceData?.returnTag != null && invoiceData.invoiceData?.returnTag != "") {
              totalValue = totalValue + item.productOrCategoryDiscount * item.quantity;
              rawTotalValue = rawTotalValue + item.productOrCategoryDiscount * item.quantity;
            } else {
              totalValue = totalValue - item.productOrCategoryDiscount * item.quantity;
              rawTotalValue = rawTotalValue - item.productOrCategoryDiscount * item.quantity;
            }
          } else {
            if (invoiceData.invoiceData?.returnTag != null && invoiceData.invoiceData?.returnTag != "") {
              totalValue = totalValue + (item.amount * item.productOrCategoryDiscount) / 100;
              rawTotalValue = rawTotalValue + (item.amount * item.productOrCategoryDiscount) / 100;
            } else {
              totalValue = totalValue - (item.amount * item.productOrCategoryDiscount) / 100;
              rawTotalValue = rawTotalValue - (item.amount * item.productOrCategoryDiscount) / 100;
            }
          }
          setinvoiceValueWithDiscounts(rawTotalValue);
          setUpdatedInvoiceValue(totalValue);
          setIsProductOrCategoryDiscountsAvailable(true);
        }
      });
    }

    if (invoiceData.invoiceData?.discount > 0) {
      if (invoiceData.invoiceData?.discountType == 'PAYRATE') {
        setfirstFieldAmount(invoiceData.invoiceData?.discount);
        totalValue = totalValue - invoiceData.invoiceData?.discount;
      } else {
        setfirstFieldAmount(totalValue * (invoiceData.invoiceData?.discount / 100)
        );
        totalValue = totalValue - totalValue * (invoiceData.invoiceData?.discount / 100);
      }
    }

    if (
      invoiceData.invoiceData?.appliedLoyaltyPoints != null &&
      invoiceData.invoiceData?.appliedLoyaltyPoints != undefined &&
      invoiceData.invoiceData?.appliedLoyaltyPoints != 0
    ) {
      totalValue = totalValue - invoiceData.invoiceData?.appliedLoyaltyPoints;
    }

    setUpdatedInvoiceValue(totalValue);

    setInvoiceValueAfterCharge(totalValue);
    let finalInvoiceValue = totalValue;

    if (
      invoiceData.invoiceData?.serviceCharge != null &&
      invoiceData.invoiceData?.serviceCharge != undefined &&
      invoiceData.invoiceData?.serviceCharge != 0
    ) {
      if (invoiceData.invoiceData?.serviceChargeType == 'PAYRATE') {
        setServiceCharge(invoiceData.invoiceData?.serviceCharge);
        finalInvoiceValue =
          finalInvoiceValue + invoiceData.invoiceData?.serviceCharge;
      } else {
        setServiceCharge(
          (totalValue * invoiceData.invoiceData?.serviceCharge) / 100
        );
        finalInvoiceValue =
          finalInvoiceValue +
          (totalValue * invoiceData.invoiceData?.serviceCharge) / 100;
      }
    }

    if (
      invoiceData.invoiceData?.cardPaymentCharge != null &&
      invoiceData.invoiceData?.cardPaymentCharge != undefined &&
      invoiceData.invoiceData?.cardPaymentCharge != 0
    ) {
      if (invoiceData.invoiceData?.cardPaymentChargeType == 'PAYRATE') {
        setCardPaymentCharge(invoiceData.invoiceData?.cardPaymentCharge);
        finalInvoiceValue =
          finalInvoiceValue + invoiceData.invoiceData?.cardPaymentCharge;
      } else {
        setCardPaymentCharge(
          (totalValue * invoiceData.invoiceData?.cardPaymentCharge) / 100
        );
        finalInvoiceValue =
          finalInvoiceValue +
          (totalValue * invoiceData.invoiceData?.cardPaymentCharge) / 100;
      }
    }

    if (
      invoiceData.invoiceData?.digitalPaymentCharge != null &&
      invoiceData.invoiceData?.digitalPaymentCharge != undefined &&
      invoiceData.invoiceData?.digitalPaymentCharge != 0
    ) {
      if (invoiceData.invoiceData?.digitalPaymentChargeType == 'PAYRATE') {
        setDigitalPaymentCharge(invoiceData.invoiceData?.digitalPaymentCharge);
        finalInvoiceValue =
          finalInvoiceValue + invoiceData.invoiceData?.digitalPaymentCharge;
      } else {
        setDigitalPaymentCharge(
          (totalValue * invoiceData.invoiceData?.digitalPaymentCharge) / 100
        );
        finalInvoiceValue =
          finalInvoiceValue +
          (totalValue * invoiceData.invoiceData?.digitalPaymentCharge) / 100;
      }
    }


    if (
      invoiceData.invoiceData?.taxCharge != null &&
      invoiceData.invoiceData?.taxCharge != undefined &&
      invoiceData.invoiceData?.taxCharge != 0
    ) {
      if (invoiceData.invoiceData?.taxChargeType == 'PAYRATE') {
        setTaxCharge(invoiceData.invoiceData?.taxCharge);
        finalInvoiceValue =
          finalInvoiceValue + invoiceData.invoiceData?.taxCharge;
      } else {
        setTaxCharge((totalValue * invoiceData.invoiceData?.taxCharge) / 100);
        finalInvoiceValue =
          finalInvoiceValue +
          (totalValue * invoiceData.invoiceData?.taxCharge) / 100;
      }
    }

    if (
      invoiceData.invoiceData?.deliveryCharge != null &&
      invoiceData.invoiceData?.deliveryCharge != undefined &&
      invoiceData.invoiceData?.deliveryCharge != 0
    ) {
      setDeliveryCharge(invoiceData.invoiceData?.deliveryCharge);
      finalInvoiceValue =
        finalInvoiceValue + invoiceData.invoiceData?.deliveryCharge;
    }

    if (
      invoiceData.invoiceData?.labourCharge != null &&
      invoiceData.invoiceData?.labourCharge != undefined &&
      invoiceData.invoiceData?.labourCharge != 0
    ) {
      setLabourCharge(invoiceData.invoiceData?.labourCharge);
      finalInvoiceValue =
        finalInvoiceValue + invoiceData.invoiceData?.labourCharge;
    }
    setInvoiceValueAfterCharge(finalInvoiceValue);

    if (invoiceData.invoiceData?.creditSettleValues != null) {
      setCreditSettleValues(invoiceData.invoiceData?.creditSettleValues);
    }

    getTotalOutstandingAmountByCustomerId(
      invoiceData.invoiceData?.shopId?._id,
      invoiceData.invoiceData?.customerId
    );
  }, [invoiceData]);

  const getTotalOutstandingAmountByCustomerId = async (
    shopId: string,
    customerId: string
  ) => {
    const response = await InvoiceService.getTotalOutstandingAmountByCustomerId(
      shopId,
      customerId
    );
    if (response.success) {
      setTotalOustandingAmount(response.data);
      setIsLoading(false);
    } else {
      setError(response.error);
      setErrorOccurred(true);
    }
  };

  const subTotalValue = Number(invoiceData.invoiceData?.subTotal || 0);
  const shopLoyaltyRate = Number(
    invoiceData.invoiceData?.shopId?.customerLoyaltyPoints || 0
  );
  const storedEarnedLoyaltyPoints = invoiceData.invoiceData?.earnedLoyaltyPoints;
  const earnedLoyaltyPoints =
    storedEarnedLoyaltyPoints != null && storedEarnedLoyaltyPoints != undefined
      ? Number(storedEarnedLoyaltyPoints || 0)
      : invoiceData.invoiceData?.customerId &&
        shopLoyaltyRate > 0 &&
        subTotalValue > 0
        ? Number(((subTotalValue / 1000) * shopLoyaltyRate).toFixed(2))
        : 0;
  const addToLoyaltyPoints = Number(
    invoiceData.invoiceData?.addToLoyaltyPoints || 0
  );

  let totalItemDiscount = 0;

  if (invoiceData.invoiceData?.invoiceItems && invoiceData.invoiceData?.invoiceItems.length > 0) {
    invoiceData.invoiceData?.invoiceItems.forEach((item: any) => {
      if (item.productOrCategoryDiscount && item.productOrCategoryDiscount > 0) {
        if (item.productOrCategoryDiscountType === "PAYRATE") {
          totalItemDiscount += item.productOrCategoryDiscount * item.quantity;
        } else {
          totalItemDiscount += +(
            item.amount * (item.productOrCategoryDiscount / 100)
          ).toFixed(2);
        }
      }
    });
  }

  return (
    <>
      <div className="bottom-section-container">

        {(firstFieldAmount || isProductOrCategoryDiscountsAvailable) && (
          <>
            <div className="seperate-line">
              <div className="sl"></div>
            </div>

            <div className="inv-sec">
              <div className="inv-sec1"><b>Sub Total:</b></div>
              <div className="inv-sec2"><b>
                {Util.formatNumber(Math.abs(invoiceData.invoiceData?.subTotal))} {invoiceCurrency}
              </b></div>
            </div>
          </>
        )}

        {totalItemDiscount > 0 && (
          <>
            <div className="inv-sec">
              <div className="inv-sec1">Total Item Discount:</div>
              <div className="inv-sec2">
                -{Util.formatNumber(totalItemDiscount)} {invoiceCurrency}
              </div>
            </div>

          </>
        )
        }

        {invoiceData.invoiceData?.discount != null &&
          invoiceData.invoiceData?.discount != undefined &&
          invoiceData.invoiceData?.discount != 0 && (
            <>

              <div className="inv-sec">
                <div className="inv-sec1">
                  {invoiceData.invoiceData?.firstFieldType !== "Discount" ? invoiceData.invoiceData?.firstFieldType : 'Invoice Discount'}{' '}
                  {invoiceData.invoiceData?.discountType != 'PAYRATE'
                    ? `[${invoiceData.invoiceData?.discount}%]`
                    : ''}
                  :
                </div>
                <div className="inv-sec2">
                  -{Util.formatNumber(firstFieldAmount)} {invoiceCurrency}
                </div>
              </div>
            </>
          )
        }

        {invoiceData.invoiceData?.appliedLoyaltyPoints != null &&
          invoiceData.invoiceData?.appliedLoyaltyPoints != undefined &&
          invoiceData.invoiceData?.appliedLoyaltyPoints != 0 && (
            <div className="inv-sec">
              <div className="inv-sec1">Applied Loyalty Points:</div>
              <div className="inv-sec2">
                -{Util.formatNumber(invoiceData.invoiceData?.appliedLoyaltyPoints)} {invoiceCurrency}
              </div>
            </div>
          )}

        {invoiceData.invoiceData?.serviceCharge != null &&
          invoiceData.invoiceData?.serviceCharge != undefined &&
          invoiceData.invoiceData?.serviceCharge != 0 && (
            <>
              <div className="inv-sec">
                <div className="inv-sec1">
                  Service Charge:{' '}
                  {invoiceData.invoiceData?.serviceChargeType == 'PERCENTAGE' &&
                    `[${invoiceData.invoiceData?.serviceCharge}%]`}
                </div>
                <div className="inv-sec2">
                  +{Util.formatNumber(serviceCharge)} {invoiceCurrency}
                </div>
              </div>

              <div className="seperate-line">
                <div className="sl"></div>
              </div>
            </>
          )}

        {invoiceData.invoiceData?.cardPaymentCharge != null &&
          invoiceData.invoiceData?.cardPaymentCharge != undefined &&
          invoiceData.invoiceData?.cardPaymentCharge != 0 && (
            <>
              <div className="inv-sec">
                <div className="inv-sec1">
                  Card Payment Charge:{' '}
                  {invoiceData.invoiceData?.cardPaymentChargeType == 'PERCENTAGE' &&
                    `[${invoiceData.invoiceData?.cardPaymentCharge}%]`}
                </div>
                <div className="inv-sec2">
                  +{Util.formatNumber(cardPaymentCharge)} {invoiceCurrency}
                </div>
              </div>

              <div className="seperate-line">
                <div className="sl"></div>
              </div>
            </>
          )}

        {invoiceData.invoiceData?.digitalPaymentCharge != null &&
          invoiceData.invoiceData?.digitalPaymentCharge != undefined &&
          invoiceData.invoiceData?.digitalPaymentCharge != 0 && (
            <>
              <div className="inv-sec">
                <div className="inv-sec1">
                  Digital Payment Charge:{' '}
                  {invoiceData.invoiceData?.digitalPaymentChargeType == 'PERCENTAGE' &&
                    `[${invoiceData.invoiceData?.digitalPaymentCharge}%]`}
                </div>
                <div className="inv-sec2">
                  +{Util.formatNumber(digitalPaymentCharge)} {invoiceCurrency}
                </div>
              </div>

              <div className="seperate-line">
                <div className="sl"></div>
              </div>
            </>
          )}

        {invoiceData.invoiceData?.taxCharge != null &&
          invoiceData.invoiceData?.taxCharge != undefined &&
          invoiceData.invoiceData?.taxCharge != 0 && (
            <>
              <div className="inv-sec">
                <div className="inv-sec1">
                  Tax Charge:{' '}
                  {invoiceData.invoiceData?.taxChargeType == 'PERCENTAGE' &&
                    `[${invoiceData.invoiceData?.taxCharge}%]`}
                </div>
                <div className="inv-sec2">
                  +{Util.formatNumber(taxCharge)} {invoiceCurrency}
                </div>
              </div>

              <div className="seperate-line">
                <div className="sl"></div>
              </div>
            </>
          )}

        {invoiceData.invoiceData?.deliveryCharge != null &&
          invoiceData.invoiceData?.deliveryCharge != undefined &&
          invoiceData.invoiceData?.deliveryCharge != 0 && (
            <>
              <div className="inv-sec">
                <div className="inv-sec1">{invoiceData?.invoiceData?.thirdFieldType ?? "Delivery"} Charge:</div>
                <div className="inv-sec2">
                  +{Util.formatNumber(deliveryCharge)} {invoiceCurrency}
                </div>
              </div>

              <div className="seperate-line">
                <div className="sl"></div>
              </div>
            </>
          )}

        {invoiceData.invoiceData?.labourCharge != null &&
          invoiceData.invoiceData?.labourCharge != undefined &&
          invoiceData.invoiceData?.labourCharge != 0 && (
            <>
              <div className="inv-sec">
                <div className="inv-sec1">Labour Charge:</div>
                <div className="inv-sec2">
                  +{Util.formatNumber(labourCharge)} {invoiceCurrency}
                </div>
              </div>

              <div className="seperate-line">
                <div className="sl"></div>
              </div>
            </>
          )}



        <div className="inv-sec">
          <div className="inv-sec1">
            <b>Total:</b>
          </div>
          <div className="inv-sec2">
            <b>
              {Util.formatNumber(Math.abs(invoiceValueAfterCharge))} {invoiceCurrency}
            </b>
          </div>
        </div>

        {earnedLoyaltyPoints > 0 && (
          <div className="inv-sec">
            <div className="inv-sec1">Earned Loyalty Points</div>
            <div className="inv-sec2">
              {Util.formatNumber(earnedLoyaltyPoints)}
            </div>
          </div>
        )}

        <div className="seperate-line">
          <div className="sl"></div>
        </div>

        {invoiceData.invoiceData?.paymentOption != null &&
          invoiceData.invoiceData?.paymentOption == PaymentOptions.CASH &&
          invoiceData.invoiceData?.invoiceNumber != "PRE-INVOICE" && (
            <>
              <div className="inv-sec">
                <div className="inv-sec1">
                  <b>Cash Invoice</b>
                </div>
                <div className="inv-sec2"></div>
              </div>

              <div className="inv-sec">
                <div className="inv-sec1">Paid Amount</div>
                <div className="inv-sec2">
                  {Util.formatNumber(invoiceData.invoiceData?.paidAmount)}{' '}
                  {invoiceCurrency}
                </div>
              </div>

              {addToLoyaltyPoints > 0 && (
                <div className="inv-sec">
                  <div className="inv-sec1">Add to Loyalty Points</div>
                  <div className="inv-sec2">
                    {Util.formatNumber(addToLoyaltyPoints)} {invoiceCurrency}
                  </div>
                </div>
              )}

              <div className="inv-sec">
                <div className="inv-sec1">
                  <b>Balance</b>
                </div>
                <div className="inv-sec2">
                  <b>
                    {Util.formatNumber(invoiceData.invoiceData?.balance)}{' '}
                    {invoiceCurrency}
                  </b>
                </div>
              </div>
            </>
          )}

        {invoiceData.invoiceData?.paymentOption != null &&
          invoiceData.invoiceData?.paymentOption == PaymentOptions.CREDIT && (
            <>
              <div className="inv-sec">
                <div className="inv-sec1">
                  <b>Credit Invoice</b>
                </div>
                <div className="inv-sec2"></div>
              </div>

              {invoiceData.invoiceData?.invoicePaidAmount
                ? (
                  <div className="inv-sec">
                    <div className="inv-sec1">Invoice Paid Amount</div>
                    <div className="inv-sec2">
                      {Util.formatNumber(invoiceData.invoiceData.invoicePaidAmount)} {invoiceCurrency}
                    </div>
                  </div>
                )
                : null}

              <div className="inv-sec">
                <div className="inv-sec1">Paid Amount</div>
                <div className="inv-sec2">
                  {Util.formatNumber(invoiceData.invoiceData?.paidAmount)}{' '}
                  {invoiceCurrency}
                </div>
              </div>

              <div className="inv-sec">
                <div className="inv-sec1">Outstanding</div>
                <div className="inv-sec2">
                  <b>
                    {Util.formatNumber(
                      invoiceData.invoiceData?.outstandingAmount
                    )}{' '}
                    {invoiceCurrency}
                  </b>
                </div>
              </div>

              {creditSettleValues && creditSettleValues.length > 0 && (
                <>
                  <div className="summary-sec" style={{ fontWeight: "bold", fontSize: "13px", color: "#989898", marginBottom: "0px" }}>
                    Credit Settlement History
                  </div>
                  {creditSettleValues
                    .sort((a, b) => {
                      const dateA = a.settledDate ? new Date(a.settledDate) : new Date(0);
                      const dateB = b.settledDate ? new Date(b.settledDate) : new Date(0);
                      return dateB.getTime() - dateA.getTime();
                    })
                    .map((entry, index) => {
                      let formattedDate = "Invalid Date";
                      if (entry.settledDate) {
                        if (typeof entry.settledDate === "string" || entry.settledDate instanceof Date) {
                          formattedDate = moment(entry.settledDate).format("D MMM YYYY");
                        } else if (typeof entry.settledDate === "object" && entry.settledDate.$date) {
                          formattedDate = moment(entry.settledDate.$date).format("D MMM YYYY");
                        }
                      }
                      return (
                        <div className="summary-sec-row" key={index}>
                          <div className="sub-sec1">{formattedDate}</div>
                          <div className="sub-sec3">
                            {Util.formatNumber(entry.settledAmount)} {invoiceCurrency}
                          </div>
                        </div>
                      );
                    })}
                </>
              )}

              {totalOustandingAmount != null &&
                totalOustandingAmount != undefined &&
                totalOustandingAmount.summary && (
                  <>
                    <div className="summary-sec">Outstanding Bill Summary</div>

                    {totalOustandingAmount.summary.map((summary, index) => {
                      const formattedDate = moment(summary.createdDate, 'D/M/YYYY').format('DD MMM YYYY');
                      return (
                        <div className="summary-sec-row" key={index}>
                          <div className="sub-sec1">{formattedDate}</div>
                          <div className="sub-sec2">
                            {summary.invoiceNumber}
                          </div>
                          <div className="sub-sec3">
                            {Util.formatNumber(summary.outstandingAmount)}{' '}
                            {invoiceCurrency}
                          </div>
                        </div>
                      );
                    })}

                    <div className="inv-sec">
                      <div className="inv-sec1">Total Outstanding</div>
                      <div className="inv-sec2">
                        <b>
                          {Util.formatNumber(
                            totalOustandingAmount.totalOutstandingAmount
                          )}{' '}
                          {invoiceCurrency}
                        </b>
                      </div>
                    </div>
                  </>
                )}
            </>
          )}

        {invoiceData.invoiceData?.paymentOption != null &&
          invoiceData.invoiceData?.paymentOption == PaymentOptions.CHEQUE && (
            <>
              <div className="inv-sec">
                <div className="inv-sec1">
                  <b>Cheque Invoice</b>
                </div>
                <div className="inv-sec2"></div>
              </div>
              <div className="inv-sec">
                <div className="inv-sec1">Paid Amount</div>
                <div className="inv-sec2">
                  {Util.formatNumber(invoiceData.invoiceData?.paidAmount)}{' '}
                  {invoiceCurrency}
                </div>
              </div>
              <div className="inv-sec">
                <div className="inv-sec1">Cheque Amount</div>
                <div className="inv-sec2">
                  {Util.formatNumber(invoiceData.invoiceData?.chequeAmount)}{' '}
                  {invoiceCurrency}
                </div>
              </div>
              <div className="inv-sec">
                <div className="inv-sec1">Cheque Settle Outstanding</div>
                <div className="inv-sec2">
                  {Util.formatNumber(invoiceData.invoiceData?.chequeSettleOutstanding)}{' '}
                  {invoiceCurrency}
                </div>
              </div>
              {invoiceData.invoiceData?.chequeNo && (
                <div className="inv-sec">
                  <div className="inv-sec1">Cheque Number</div>
                  <div className="inv-sec2">
                    <b>{invoiceData.invoiceData?.chequeNo}</b>
                  </div>
                </div>
              )}
            </>
          )}


        {invoiceData.invoiceData?.paymentOption != null &&
          invoiceData.invoiceData?.paymentOption ==
          PaymentOptions.CASH_ON_DELIVERY && (
            <>
              <div className="inv-sec">
                <div className="inv-sec1">
                  <b>Cash On Delivery Invoice</b>
                </div>
                <div className="inv-sec2"></div>
              </div>

              <div className="inv-sec">
                <div className="inv-sec1">Paid Amount</div>
                <div className="inv-sec2">
                  {Util.formatNumber(invoiceData.invoiceData?.paidAmount)}{' '}
                  {invoiceCurrency}
                </div>
              </div>

              <div className="inv-sec">
                <div className="inv-sec1">COD Amount</div>
                <div className="inv-sec2">
                  {Util.formatNumber(invoiceData.invoiceData?.outstandingCODAmount)}{' '}
                  {invoiceCurrency}
                </div>
              </div>

              {invoiceData.invoiceData?.waybillNumber != null &&
                invoiceData.invoiceData.waybillNumber.trim() !== "" && (
                  <div className="inv-sec">
                    <div className="inv-sec1">Waybill Number</div>
                    <div className="inv-sec2">
                      {invoiceData.invoiceData.waybillNumber}
                    </div>
                  </div>
                )}
            </>
          )}


        {invoiceData.invoiceData?.paymentOption != null &&
          invoiceData.invoiceData?.paymentOption ==
          PaymentOptions.BANK_TRANSFER && (
            <>
              <div className="inv-sec">
                <div className="inv-sec1">
                  <b>Bank Transfer Invoice</b>
                </div>
                <div className="inv-sec2"></div>
              </div>

              <div className="inv-sec">
                <div className="inv-sec1">Paid Amount</div>
                <div className="inv-sec2">
                  {Util.formatNumber(invoiceData.invoiceData?.paidAmount)}{' '}
                  {invoiceCurrency}
                </div>
              </div>

              <div className="inv-sec">
                <div className="inv-sec1">Bank Transfer Amount</div>
                <div className="inv-sec2">
                  {Util.formatNumber(invoiceData.invoiceData?.bankTransferAmount)}{' '}
                  {invoiceCurrency}
                </div>
              </div>

              <div className="inv-sec">
                <div className="inv-sec1">
                  <b>
                    {invoiceData.invoiceData?.bankName}
                    {invoiceData.invoiceData?.bankAccountNumber && ` - ${invoiceData.invoiceData.bankAccountNumber}`}
                  </b>
                </div>
              </div>
            </>
          )}

        {invoiceData.invoiceData?.paymentOption != null &&
          invoiceData.invoiceData?.paymentOption ==
          PaymentOptions.CARD_PAYMENT && (
            <>
              <div className="inv-sec">
                <div className="inv-sec1">
                  <b>Card Payment Invoice</b>
                </div>
                <div className="inv-sec2"></div>
              </div>

              <div className="inv-sec">
                <div className="inv-sec1">Paid Amount</div>
                <div className="inv-sec2">
                  {Util.formatNumber(invoiceData.invoiceData?.paidAmount)}{' '}
                  {invoiceCurrency}
                </div>
              </div>

              <div className="inv-sec">
                <div className="inv-sec1">Card Payment Amount</div>
                <div className="inv-sec2">
                  {Util.formatNumber(invoiceData.invoiceData?.cardPaymentAmount)}{' '}
                  {invoiceCurrency}
                </div>
              </div>
            </>
          )}

        {invoiceData.invoiceData?.paymentOption != null &&
          invoiceData.invoiceData?.paymentOption ==
          PaymentOptions.QR_PAYMENT && (
            <>
              <div className="inv-sec">
                <div className="inv-sec1">
                  <b>QR Payment Invoice</b>
                </div>
                <div className="inv-sec2"></div>
              </div>

              <div className="inv-sec">
                <div className="inv-sec1">Paid Amount</div>
                <div className="inv-sec2">
                  {Util.formatNumber(invoiceData.invoiceData?.paidAmount)}{' '}
                  {invoiceCurrency}
                </div>
              </div>

              <div className="inv-sec">
                <div className="inv-sec1">QR Payment Amount</div>
                <div className="inv-sec2">
                  {Util.formatNumber(invoiceData.invoiceData?.qrPaymentAmount)}{' '}
                  {invoiceCurrency}
                </div>
              </div>
            </>
          )}

        {invoiceData.invoiceData?.paymentOption != null &&
          invoiceData.invoiceData?.paymentOption ==
          PaymentOptions.DIGITAL_PAYMENT && (
            <>
              <div className="inv-sec">
                <div className="inv-sec1">
                  <b>Digital Payment Invoice</b>
                </div>
                <div className="inv-sec2"></div>
              </div>

              <div className="inv-sec">
                <div className="inv-sec1">Paid Amount</div>
                <div className="inv-sec2">
                  {Util.formatNumber(invoiceData.invoiceData?.paidAmount)}{' '}
                  {invoiceCurrency}
                </div>
              </div>

              <div className="inv-sec">
                <div className="inv-sec1">Digital Payment Method</div>
                <div className="inv-sec2">
                  <b>
                    {invoiceData.invoiceData?.digitalPaymentMethod}

                  </b>
                </div>
              </div>
            </>
          )}


      </div>
    </>
  );
};

export default BottomSection;
